export const APP_VERSION = "Version : 3.8.9"
